import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
  Brain, HardHat, MessageSquare, Factory, ChevronRight, ChevronLeft,
  Quote, Wrench, Lightbulb, Package, BatteryCharging, Users, Phone, Link2
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './Home.css';
import AnimatedCounter from '../../components/AnimatedCounter';
import SEO from '../../components/SEO';
import HomePillarContent from '../../components/HomePillarContent';
import CustomerReviewsSection from '../../components/CustomerReviewsSection';
import DiscountsSection from '../../components/DiscountsSection';
import { areas, regionsByGovernorate } from '../../data/areas.js';
import { toArabicSlug } from '../../data/areaSlugMapping';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import extraImg1 from '../../images/WhatsApp Image 2025-07-02 at 15.02.33_fe153007.webp';
import extraImg2 from '../../images/WhatsApp Image 2025-07-02 at 15.02.33_732c1eeb.webp';
import extraImg3 from '../../images/fuel.webp';
import extraImg4 from '../../images/battary.webp';
import extraImg5 from '../../images/images (3).webp';
import towImage from '../../images/tow.webp';
import towImage2 from '../../images/tow-2.webp';
import toyota from "../../images/cars/toyota.webp";
import Volkswagen from "../../images/cars/Volkswagen.webp";
import volvo from "../../images/cars/volvo.webp";
import audi from "../../images/cars/audi.webp";
import bmw from "../../images/cars/bmw.webp";
import byd from "../../images/cars/byd.webp";
import Chevrolet from "../../images/cars/Chevrolet.webp";
import Hyundai from "../../images/cars/Hyundai.webp";
import jeep from "../../images/cars/jeep.webp";
import kia from "../../images/cars/kia.webp";
import mazda from "../../images/cars/mazda.webp";
import mercedes from "../../images/cars/mercedes.webp";
import minicooper from "../../images/cars/minicooper.webp";
import Nissan from "../../images/cars/Nissan.webp";
import Peugeot from "../../images/cars/Peugeot.webp";
import skoda from "../../images/cars/skoda.webp";
import subaru from "../../images/cars/subaru.webp";
import whatsapp1 from '../../images/WhatsApp Image 2025-07-02 at 15.02.33_fe153007.webp';
import whatsapp2 from '../../images/WhatsApp Image 2025-07-02 at 15.02.33_732c1eeb.webp';
import whatsapp3 from '../../images/WhatsApp Image 2025-07-02 at 15.02.33_0b194e2d.webp';
import whatsapp4 from '../../images/WhatsApp Image 2025-07-02 at 15.02.32_bc1bb19d.webp';
import whatsapp6 from '../../images/WhatsApp Image 2025-07-02 at 15.02.32_00a9c303.webp';
import whatsapp7 from '../../images/WhatsApp Image 2025-07-02 at 15.02.32_a2d1fc1d.webp';
import whatsapp8 from '../../images/WhatsApp Image 2025-07-02 at 15.02.31_d02e6e11.webp';
import whatsapp9 from '../../images/WhatsApp Image 2025-07-02 at 15.02.31_0da1e2e8.webp';
import whatsapp10 from '../../images/WhatsApp Image 2025-07-02 at 15.02.31_58370244.webp';
import whatsapp11 from '../../images/WhatsApp Image 2025-07-02 at 15.02.31_d875b30c.webp';
const whatsappImages = [
  whatsapp1, whatsapp2, whatsapp3, whatsapp4, whatsapp6,
  whatsapp7, whatsapp8, whatsapp9, whatsapp10, whatsapp11
];

const galleryAltList = [
  "ونش انقاذ سيارات حديث لسحب ونقل السيارات الملاكي والـ SUV بأمان",
  "سطحة هيدروليكية كاملة لرفع السيارات المنخفضة والفارهة بدون أي خدوش",
  "فريق ونش انقاذ محمد بحر الميداني لخدمات الطوارئ على مدار 24 ساعة",
  "عملية سحب سيارة معطلة بأمان تام على الطرق السريعة والمحاور",
  "ونش شوكة مدمج مخصص للإنقاذ السريع داخل الشوارع السكنية والجراجات",
  "سيارة ونش مجهزة بأحدث معدات الجر وسلاسل الأمان في القاهرة والجيزة",
  "إنقاذ ونقل سيارات الحوادث بدقة واحترافية عالية وبأسرع وقت",
  "خدمة المساعدة على الطريق وتغيير الإطارات وشحن البطارية في الموقع",
  "أسطول أوناش إنقاذ محمد بحر متمركز على المحاور والطرق الحيوية",
  "خدمة سريعة لنقل السيارات بين المحافظات بأرخص الأسعار وخصم 50%"
];

const partners = [
  { src: toyota, alt: "Toyota" },
  { src: Volkswagen, alt: "Volkswagen" },
  { src: volvo, alt: "Volvo" },
  { src: audi, alt: "Audi" },
  { src: bmw, alt: "BMW" },
  { src: byd, alt: "BYD" },
  { src: Chevrolet, alt: "Chevrolet" },
  { src: Hyundai, alt: "Hyundai" },
  { src: jeep, alt: "Jeep" },
  { src: kia, alt: "Kia" },
  { src: mazda, alt: "Mazda" },
  { src: mercedes, alt: "Mercedes" },
  { src: minicooper, alt: "Mini Cooper" },
  { src: Nissan, alt: "Nissan" },
  { src: Peugeot, alt: "Peugeot" },
  { src: skoda, alt: "Skoda" },
  { src: subaru, alt: "Subaru" },
];

const extraServices = [
  {
    id: 'rescue',
    icon: <Wrench size={44} color="#ffc107" style={{ marginBottom: '1rem' }} />,
    title: 'إنقاذ السيارات',
    desc: 'نقدم جميع خدمات إنقاذ السيارات بأسرع وأفضل خدمة إنقاذ للسيارات في مصر بشكل غير مسبوق ..',
  },
  {
    id: 'equipment',
    icon: <Lightbulb size={44} color="#ffc107" style={{ marginBottom: '1rem' }} />,
    title: 'نقل المعدات',
    desc: 'نقدم جميع خدمات نقل المعدات " سيارات نقل ، كرفانات ، معدات وكراكات ، فشلات " وغيرها الكثير ..',
  },
  {
    id: 'fuel',
    icon: <Package size={44} color="#ffc107" style={{ marginBottom: '1rem' }} />,
    title: 'التزود بالوقود',
    desc: 'اذا نفذ وقود سيارتك فلا داعي للقلق، فنحن نقدم خدمة التزود بالوقود في الطريق، فريق ونش انقاذ محمد بحر جاهز لتزويدكم بالوقود فوراً ..',
  },
  {
    id: 'battery',
    icon: <BatteryCharging size={44} color="#ffc107" style={{ marginBottom: '1rem' }} />,
    title: 'وصلة بطارية',
    desc: 'نقدم جميع خدمات أعطال البطاريات التي تحتاج إلى وصلة أو شحن، فريق ونش انقاذ محمد بحر مجهز بأحدث كابلات الشحن لمساعدتكم فوراً ..',
  },
  {
    id: 'tires',
    icon: <Users size={44} color="#ffc107" style={{ marginBottom: '1rem' }} />,
    title: 'تغيير الاطارات',
    desc: 'اذا حصل ظرف طارئ في الطريق وقد احتجت الي تغيير او استبدال احدي اطارات سيارتك فنحن نقدم خدمة تغيير / استبدال الاطارات في الطريق ..',
  },
];

const Home = () => {
  const [areaPage, setAreaPage] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isImageTransitioning, setIsImageTransitioning] = useState(false);

  const cardsPerPage = 5;
  const totalPages = Math.ceil(areas.slice(0, 100).length / cardsPerPage);
  const startIdx = areaPage * cardsPerPage;
  const endIdx = startIdx + cardsPerPage;
  const visibleAreas = areas.slice(0, 100).slice(startIdx, endIdx);
  const winchImg = require('../../images/images.png');

  const heroImages = [towImage, towImage2];

  const totalTopAreas = Math.min(areas.length, 100);
  const paginationData = useMemo(() => ({
    currentPage: areaPage,
    totalPages,
    visibleAreas,
    isAnimating,
    totalAreasCount: totalTopAreas,
    visibleAreasCount: visibleAreas.length
  }), [areaPage, totalPages, visibleAreas, isAnimating, totalTopAreas]);

  const handlePageChange = useCallback((newPage) => {
    if (newPage < 0 || newPage >= totalPages || isAnimating) return;

    setIsAnimating(true);
    setTimeout(() => {
      setAreaPage(newPage);
      setIsAnimating(false);
    }, 300);
  }, [totalPages, isAnimating]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          handlePageChange(areaPage + 1);
          break;
        case 'ArrowRight':
          e.preventDefault();
          handlePageChange(areaPage - 1);
          break;
        case 'Home':
          e.preventDefault();
          handlePageChange(0);
          break;
        case 'End':
          e.preventDefault();
          handlePageChange(totalPages - 1);
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [areaPage, totalPages, handlePageChange]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsImageTransitioning(true);
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
        setIsImageTransitioning(false);
      }, 300);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroImages.length]);
  const phoneNumber = '01044844492';
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "كم من الوقت يستغرق وصول ونش الانقاذ؟",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "نتعهد بوصول ونش الانقاذ إلى موقعك خلال 10-15 دقيقة بحد أقصى. لدينا أسطول منتشر في جميع أنحاء القاهرة والجيزة والمحافظات لضمان أسرع استجابة ممكنة على مدار الساعة 24/7."
        }
      },
      {
        "@type": "Question",
        "name": "ما هي تكلفة خدمة ونش الانقاذ؟",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "نحن نقدم أرخص أسعار ونش الانقاذ في مصر مع خصم 50% على جميع الخدمات وبدون رسوم خفية. اتصل على 01044844492 لمعرفة السعر الفوري."
        }
      },
      {
        "@type": "Question",
        "name": "هل تعملون على مدار الساعة وطوال الأسبوع؟",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "نعم، نعمل 24 ساعة يومياً طوال أيام الأسبوع بما في ذلك العطلات الرسمية والأعياد بنفس الجودة والسرعة."
        }
      },
      {
        "@type": "Question",
        "name": "ما هي المناطق التي تغطيها خدمتكم؟",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "نغطي جميع مناطق القاهرة، الجيزة، الإسكندرية، وجميع محافظات مصر بالإضافة إلى كافة الطرق والمحاور السريعة (الدائري، السويس، السخنة، الإسكندرية الصحراوي)."
        }
      }
    ]
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "ونش انقاذ سيارات محمد بحر",
    "url": "https://winchmohamedbahr.com/"
  };

  return (
    <>
      <SEO
        title="ونش انقاذ سيارات محمد بحر | خدمة 24 ساعة - خصم 50%"
        description="ونش انقاذ محمد بحر: أسرع وأرخص خدمة ونش إنقاذ وسحب سيارات في القاهرة والجيزة وجميع محافظات مصر على مدار 24 ساعة. تغيير إطارات، شحن بطاريات، توصيل وقود. اتصل الآن 01044844492"
        path="/"
        jsonLd={[webSiteSchema, faqSchema]}
      />
      <section className="hero-section">
        <div className="hero-diagonal"></div>
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title" style={{ fontSize: '2.5rem', lineHeight: '1.3' }}>
              ونش انقاذ سيارات <span className="highlight">محمد بحر</span>
            </h1>
            <p className="hero-description">
              ونش انقاذ محمد بحر أسرع وأرخص ونش انقاذ في مصر. اتصل بنا وتحديد موقعك وسيتم ربطك بأقرب ونش إنقاذ مجهز بأحدث تقنيات الرفع السريع والآمن.
            </p>
            <div className="hero-offer">
              خدمة 24 ساعة — اتصل بنا الآن ليصلك أقرب ونش إنقاذ بخصم 50%
            </div>

            {/* Trust strip (T018 — operator data) */}
            <div className="hero-trust" style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'center', marginTop: '1rem' }}>
              <span style={{ background: '#0a2c61', color: '#fff', padding: '0.35rem 0.8rem', borderRadius: '999px', fontSize: '0.85rem', fontWeight: 600 }}>⭐ منذ 2001</span>
              <span style={{ background: '#1976d2', color: '#fff', padding: '0.35rem 0.8rem', borderRadius: '999px', fontSize: '0.85rem', fontWeight: 600 }}>⏱️ 10–15 دقيقة داخل القاهرة</span>
              <span style={{ background: '#ffc107', color: '#0a2c61', padding: '0.35rem 0.8rem', borderRadius: '999px', fontSize: '0.85rem', fontWeight: 600 }}>📍 42 ش مكرم عبيد، مدينة نصر</span>
              <span style={{ background: '#2e7d32', color: '#fff', padding: '0.35rem 0.8rem', borderRadius: '999px', fontSize: '0.85rem', fontWeight: 600 }}>24/7 خدمة متواصلة</span>
            </div>
            
            {/* Trust Strip */}
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '0.6rem',
              alignItems: 'center',
              margin: '1rem 0',
              padding: '0.6rem 1rem',
              background: 'rgba(255,255,255,0.12)',
              borderRadius: '10px',
              color: '#fff',
              fontSize: '0.95rem',
              fontWeight: 600
            }}>
              <span>⭐⭐⭐⭐⭐ 4.9/5 (أعلى تقييم)</span>
              <span>•</span>
              <span>خبرة منذ 2001 (25+ عام)</span>
              <span>•</span>
              <span>وصول 10–15 دقيقة</span>
              <span>•</span>
              <span>تتبع GPS</span>
            </div>

            <div className="hero-cta">
              <button className="cta-button" onClick={() => window.location.href = `tel:${phoneNumber}`}>
                اتصل الان
              </button>
              <div className="hero-phone" onClick={() => window.location.href = `tel:${phoneNumber}`}>
                {phoneNumber}
              </div>
              <div className="hero-phone" onClick={() => window.location.href = `tel:+201034222636`}>
                الطوارئ و خدمة العملاء: 01034222636
              </div>
            </div>
          </div>
          <div className="hero-image">
            <img
              src={heroImages[currentImageIndex]}
              alt={`ونش انقاذ سيارات محمد بحر ${currentImageIndex + 1}`}
              fetchpriority="high"
              loading="eager"
              width="600"
              height="400"
              className={`${isImageTransitioning ? 'transitioning' : 'fade-in'}`}
            />
            <div className="hero-image-indicators">
              {heroImages.map((_, index) => (
                <div
                  key={index}
                  className={`hero-image-dot ${index === currentImageIndex ? 'active' : ''}`}
                  onClick={() => {
                    setIsImageTransitioning(true);
                    setTimeout(() => {
                      setCurrentImageIndex(index);
                      setIsImageTransitioning(false);
                    }, 500);
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="areas-section">
        <div className="section-container">
          <h2 className="section-title">بعض مناطق التغطية</h2>

          <AreasGrid
            visibleAreas={visibleAreas}
            areaPage={areaPage}
            isAnimating={isAnimating}
            winchImg={winchImg}
          />

          <AreasPagination
            {...paginationData}
            onPageChange={handlePageChange}
          />

          {/* Categorized Regional Coverage Directory (All 33 Target Areas) */}
          <div className="home-sectors-directory" style={{ marginTop: '2.5rem', direction: 'rtl' }}>
            <h3 style={{ fontSize: '1.4rem', fontWeight: 800, color: '#0a2c61', textAlign: 'center', marginBottom: '1.5rem' }}>
              دليل التمركز السريع في الـ 33 منطقة ومحور رئيسي (وصول خلال 10-15 دقيقة)
            </h3>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '1.2rem'
            }}>
              {regionsByGovernorate.map((region, rIdx) => (
                <div key={rIdx} style={{
                  background: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  borderRadius: '1rem',
                  padding: '1.2rem',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                }}>
                  <h4 style={{ color: '#0077ff', fontWeight: 800, fontSize: '1.1rem', margin: '0 0 0.8rem 0', borderBottom: '2px solid #e0f2fe', paddingBottom: '0.4rem' }}>
                    📍 {region.name}
                  </h4>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                    {region.areas.map((a, aIdx) => (
                      <Link
                        key={aIdx}
                        to={`/areas/${toArabicSlug(a)}`}
                        style={{
                          background: '#ffffff',
                          color: '#0a2c61',
                          padding: '0.35rem 0.75rem',
                          borderRadius: '0.5rem',
                          textDecoration: 'none',
                          fontSize: '0.92rem',
                          fontWeight: 700,
                          border: '1px solid #cbd5e1',
                          transition: 'all 0.2s ease',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '0.3rem'
                        }}
                      >
                        <span>ونش {a}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="service-info-section">
        <div className="section-container">
          <div className="service-badge">ونش انقاذ سيارات</div>
          <h2 className="service-title">
            مميزات و خدمات ونش انقاذ محمد بحر لأنقاذ و رفع السيارات
          </h2>
          <div className="service-description">
            نقدم جميع خدمات <span className="highlight">سحب و انقاذ السيارات</span>، <span className="highlight">تغيير الاطارات</span>، <span className="highlight">نقل الوقود</span>، <span className="highlight">شحن بطاريات السيارة</span> وغيرها من الخدمات على مدار الساعة وبأسرع وقت وأفضل سعر في مصر.
          </div>
          <ServiceFeaturesList />
          <div className="contact-highlight">
            اتصل الآن: <span className="phone-number">{phoneNumber}</span>
          </div>
          <div className="service-details">
            <span className="highlight">خدمة 24 ساعة</span> | <span className="highlight">أسرع ونش انقاذ سيارات</span> | <span className="highlight">تغطية جميع المناطق</span> | <span className="highlight">أسعار منافسة</span> | <span className="highlight">سحب سيارات، تبديل إطارات، شحن بطارية، تزويد وقود</span>
          </div>
        </div>
      </section>
      <section className="features-section">
        <div className="section-container features-wrapper">
          <div className="features-cta">
            <div className="cta-badge">⚡ خدمة فورية ومضمونة</div>
            <h3 className="cta-heading">اطلب ونش إنقاذ سيارات الآن بكل سهولة</h3>
            <p className="cta-description">
              أسرع وأرخص ونش إنقاذ في مصر. بمجرد اتصالك وتحديد موقعك يتم توجيه أقرب ونش متمركز في نطاقك ليقوم بسحب ونقل سيارتك بأمان تام إلى أي وجهة.
            </p>
            <a href={`tel:+20${phoneNumber}`} className="cta-phone-btn">
              <Phone size={18} /> اتصل فوراً: {phoneNumber}
            </a>
          </div>
          <div className="features-grid">
            <FeatureCard
              icon={<Brain size={36} color="#0077ff" />}
              title="السرعة الفائقة"
              description="نصلك في غضون 10 إلى 15 دقيقة بحد أقصى بفضل انتشار نقاط التمركز على كافة الطرق."
            />
            <FeatureCard
              icon={<HardHat size={36} color="#0077ff" />}
              title="خدمة 24 ساعة"
              description="جاهزون لمساعدتك على مدار الساعة طوال أيام الأسبوع في أي وقت نهاراً أو ليلاً."
            />
            <FeatureCard
              icon={<MessageSquare size={36} color="#0077ff" />}
              title="الانتشار والوصول"
              description="تغطية كاملة للميادين العامة، المحاور الحرة، والطرق الصحراوية في جميع المحافظات."
            />
            <FeatureCard
              icon={<Factory size={36} color="#0077ff" />}
              title="الخبرة والاحتراف"
              description="أكثر من 20 عاماً من الخبرة مع سائقين مدربين ومعدات سحب أوروبية حديثة."
            />
          </div>
        </div>
      </section>

      <section className="quote-section">
        <div className="quote-container">
          <div className="quote-icon">
            <Quote size={80} color="#0077ff" />
          </div>
          <div className="quote-content">
            <div className="quote-title">
              لماذا يختار السائقون ونش إنقاذ سيارات <span className="highlight-name">محمد بحر</span>؟
            </div>
            <p className="quote-text-box">
              إذا كنت تبحث عن خدمة إنقاذ وسحب سيارات بأرخص سعر وأعلى معايير الأمان، فإن ونش إنقاذ محمد بحر يوفر لك حماية كاملة لسيارتك مع سرعة وصول فائقة وأسعار ثابتة معلنة بدون أي رسوم خفية على مدار 24 ساعة.
            </p>
          </div>
        </div>
      </section>

      <HomePillarContent phoneNumber={phoneNumber} />

      <section className="counter-section">
        <CounterItem target={32} prefix="+" label="سنوات من الخبرة" />
        <CounterItem target={98} suffix="%" label="عملاء سعداء" />
        <CounterItem target={13720} label="سيارة تم إنقاذها" />
        <CounterItem target={10} label="عدد اوناش الانقاذ" />
        <CounterItem target={49} label="فريق العمل" />
      </section>

      <section className="gallery-section">
        <div className="section-container">
          <h2 className="section-title">صور من أعمالنا</h2>
          <div className="gallery-grid">
            {whatsappImages.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={galleryAltList[idx] || `ونش انقاذ سيارات محمد بحر ${idx + 1}`}
                loading="lazy"
                width="300"
                height="225"
                className="gallery-image"
              />
            ))}
          </div>
        </div>
      </section>

      <section className="partners-section">
        <div className="section-container">
          <h2 className="section-title">شركاء النجاح</h2>
          <Slider
            dots={false}
            infinite={true}
            speed={700}
            slidesToShow={5}
            slidesToScroll={1}
            autoplay={true}
            autoplaySpeed={1800}
            responsive={[
              { breakpoint: 1024, settings: { slidesToShow: 4 } },
              { breakpoint: 600, settings: { slidesToShow: 2 } },
            ]}
          >
            {partners.map((partner, idx) => (
              <div key={idx} className="partner-slide">
                <img
                  src={partner.src}
                  alt={partner.alt}
                  loading="lazy"
                  width="140"
                  height="60"
                  className="partner-logo"
                />
              </div>
            ))}
          </Slider>
        </div>
      </section>

      <section className="extra-services-section">
        <div className="section-container">
          <h2 className="section-title">خدمات إضافية</h2>
          <div className="services-grid">
            {extraServices.map((service, idx) => (
              <ServiceCard
                key={service.id}
                service={service}
                image={[extraImg1, extraImg2, extraImg3, extraImg4, extraImg5][idx]}
              />
            ))}
          </div>
        </div>
      </section>

      <DiscountsSection phoneNumber={phoneNumber} />

      <CustomerReviewsSection />

      <FooterContent phoneNumber={phoneNumber} areas={areas} />
    </>
  );
};


const AreasPagination = ({
  currentPage,
  totalPages,
  isAnimating,
  onPageChange,
  visibleAreasCount,
  totalAreasCount
}) => {
  const handleKeyDown = useCallback((e, pageIndex) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onPageChange(pageIndex);
    }
  }, [onPageChange]);

  const pageIndicators = useMemo(() => {
    if (totalPages <= 1) return null;

    return Array.from({ length: totalPages }, (_, idx) => (
      <button
        key={idx}
        onClick={() => onPageChange(idx)}
        onKeyDown={(e) => handleKeyDown(e, idx)}
        disabled={isAnimating}
        className={`page-dot ${idx === currentPage ? 'active' : ''}`}
        aria-label={`انتقل إلى الصفحة ${idx + 1}`}
        title={`الصفحة ${idx + 1}`}
        role="tab"
        aria-selected={idx === currentPage}
        tabIndex={0}
      />
    ));
  }, [totalPages, currentPage, isAnimating, onPageChange, handleKeyDown]);

  return (
    <div className="pagination-container" role="navigation" aria-label="تنقل بين صفحات المناطق">
      <div className="pagination-controls">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 0 || isAnimating}
          className="pagination-btn"
          aria-label="الصفحة السابقة"
          title="الصفحة السابقة"
          aria-describedby="pagination-info"
        >
          <ChevronRight size={18} />
          السابق
        </button>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages - 1 || isAnimating}
          className="pagination-btn"
          aria-label="الصفحة التالية"
          title="الصفحة التالية"
          aria-describedby="pagination-info"
        >
          التالي
          <ChevronLeft size={18} />
        </button>
      </div>

      {pageIndicators && (
        <div className="page-indicators" role="tablist" aria-label="صفحات المناطق">
          {pageIndicators}
        </div>
      )}

      <div className="page-info" id="pagination-info" role="status" aria-live="polite">
        الصفحة {currentPage + 1} من {totalPages} • {visibleAreasCount} منطقة معروضة من {totalAreasCount}
      </div>
    </div>
  );
};

const AreasGrid = ({ visibleAreas, areaPage, isAnimating, winchImg }) => {
  if (isAnimating) {
    return (
      <div className="areas-loading">
        <span>جاري تحميل المناطق...</span>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className={`areas-fade ${isAnimating ? 'out' : 'in'} areas-section-grid`}>
      <div className="areas-small-cards">
        {visibleAreas.slice(0, 4).map((area, idx) => (
          <AreaCard
            key={`small-${areaPage}-${idx}`}
            area={area}
            isSmall={true}
            winchImg={winchImg}
          />
        ))}
      </div>
      <div className="areas-big-card">
        {visibleAreas[4] && (
          <AreaCard
            key={`large-${areaPage}-4`}
            area={visibleAreas[4]}
            isSmall={false}
            winchImg={winchImg}
          />
        )}
      </div>
    </div>
  );
};

const AreaCard = ({ area, isSmall, winchImg }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <Link
      to={`/areas/${toArabicSlug(area)}`}
      style={{ textDecoration: 'none', color: 'inherit', height: '100%' }}
    >
      <div
        className={`area-card-hover big-area-card ${isSmall ? 'area-card-small' : 'area-card-large'}`}
        style={{
          background: 'linear-gradient(135deg, #fff 60%, #e3f0ff 100%)',
          borderRadius: '1.5rem',
          boxShadow: '0 8px 32px #00336633, 0 2px 16px #0001',
          overflow: 'hidden',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          height: '100%',
          minHeight: isSmall ? '220px' : '260px',
          border: '2.5px solid #ffe066',
          transition: 'transform 0.22s cubic-bezier(.4,0,.2,1), box-shadow 0.22s cubic-bezier(.4,0,.2,1)',
        }}
      >
        <div className="area-card-image-container" style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          minHeight: isSmall ? '110px' : '220px',
          overflow: 'hidden'
        }}>
          <img
            src={winchImg}
            alt="ونش انقاذ"
            loading="lazy"
            width="600"
            height="400"
            className="area-card-image"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              filter: 'brightness(0.82) saturate(1.1)'
            }}
          />
          <div className="area-card-overlay" style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(120deg, #0a223ad0 60%, #1976d2cc 100%)',
            zIndex: 2,
            pointerEvents: 'none',
          }}></div>

          {!isSmall && !isMobile && (
            <div className="area-card-badge" style={{
              position: 'absolute',
              top: '1.2rem',
              right: '1.2rem',
              zIndex: 3,
              background: '#ffe066',
              color: '#0a2c61',
              borderRadius: '1.2rem',
              padding: '0.4rem 1.2rem',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              boxShadow: '0 2px 8px #0002',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              letterSpacing: '0.5px'
            }}>
              <span style={{ fontSize: '1.3rem', marginLeft: '0.3rem' }}>⚡</span>
              خدمة مميزة
            </div>
          )}

          <div className={`area-card-content-home ${isSmall ? 'area-card-content-small' : 'area-card-content-large'}`} style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '90%',
            zIndex: 3,
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-end',
          }}>
            <div className={`area-card-title ${isSmall ? 'area-card-title-small' : 'area-card-title-large'}`} style={{
              fontWeight: 'bold',
              marginBottom: '0.5rem',
              textShadow: '0 2px 8px #0008',
              color: '#ffe066',
              letterSpacing: '1px',
              lineHeight: 1.2,
              background: 'linear-gradient(90deg, #ffe066 60%, #fffbe6 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',

            }}>ونش انقاذ {area}</div>

            {!isSmall && (
              <div className="area-card-description" style={{
                marginBottom: '1.2rem',
                textShadow: '0 2px 8px #0008',
                color: '#fff',
                fontWeight: 500,
              }}>
                نقوم بتوفير الوقت عليك في البحث عن ونش إنقاذ سيارات في <span style={{ color: '#ffe066', fontWeight: 'bold' }}>{area.replace('ونش انقاذ ', '')}</span> نحن الشركة رقم 1 في مصر ولدينا أرخص الأسعار.
              </div>
            )}

            {!isSmall && (
              <span className="area-card-service-badge" style={{
                background: '#ffe066',
                color: '#0a2c61',
                borderRadius: '1.2rem',
                fontWeight: 'bold',
                boxShadow: '0 2px 8px #0002',
                letterSpacing: '0.5px'
              }}>خدمة على مدار الساعة</span>
            )}

            <button className="area-card-button" style={{
              background: 'linear-gradient(90deg, #ffe066 60%, #ffb100 100%)',
              color: '#0a2c61',
              border: 'none',
              borderRadius: '0.7rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 2px 8px #0002',
              transition: 'background 0.18s',
            }}>اتصل الآن</button>
          </div>
        </div>
      </div>
    </Link>
  );
};

const FeatureCard = ({ icon, title, description }) => (
  <div className="feature-card-box">
    <div className="feature-card-icon-wrap">{icon}</div>
    <h4 className="feature-card-heading">{title}</h4>
    <p className="feature-card-paragraph">{description}</p>
  </div>
);

const CounterItem = ({ target, prefix = "", suffix = "", label }) => (
  <div className="counter-item" style={{ flex: 1, textAlign: 'center', borderLeft: '1px solid #f7e600', padding: '0 0.5rem' }}>
    <div style={{ fontSize: '3rem', color: '#003366', fontWeight: 700, fontFamily: 'Tajawal, sans-serif', marginBottom: '0.5rem' }}>
      <AnimatedCounter target={target} prefix={prefix} suffix={suffix} />
    </div>
    <div style={{ fontWeight: 'bold', color: '#222', fontSize: '1rem' }}>{label}</div>
  </div>
);

const ServiceCard = ({ service, image }) => (
  <Link
    to={`/service/${service.id}`}
    style={{ textDecoration: 'none', flex: '1 1 220px', maxWidth: '350px', minWidth: '220px', display: 'flex', margin: "auto" }}
  >
    <div
      style={{
        background: 'var(--color-muted)',
        color: 'var(--color-text)',
        borderRadius: '1rem',
        padding: '2rem 1rem',
        boxShadow: '0 0 40px #00384466 ',
        textAlign: 'center',
        transition: 'transform 0.2s',
        fontWeight: 500,
        minHeight: '200px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
      className="service-card-hover"
    >
      {service.icon}
      <div style={{ fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.7rem' }}>{service.title}</div>
      <div style={{ fontSize: '1rem' }}>{service.desc}</div>
      <img
        src={image}
        alt={service.title}
        loading="lazy"
        width="200"
        height="200"
        style={{
          width: '100%',
          borderRadius: '0.7rem',
          margin: '1rem auto 1rem auto',
          display: 'block',
          boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
        }}
      />
    </div>
  </Link>
);


const ServiceFeaturesList = () => (
  <ul style={{ color: '#222', fontSize: '1.08rem', marginBottom: '1.2rem', paddingRight: '1.5rem', lineHeight: 2 }}>
    <li><span className="highlight">سحب و انقاذ السيارات:</span> نوفر جميع خدمات السحب والرفع لأي نوع سيارة وفي أي مكان.</li>
    <li><span className="highlight">تغيير الاطارات:</span> نصل إليك أينما كنت ونساعدك في تغيير أو إصلاح الإطار المعطل.</li>
    <li><span className="highlight">نقل الوقود:</span> إذا نفد وقود سيارتك، اتصل بنا وسنصل إليك فوراً لتزويدك بالوقود.</li>
    <li><span className="highlight">شحن بطاريات السيارة:</span> خدمة شحن البطارية متوفرة في أي وقت.</li>
  </ul>
);

const FooterContent = ({ phoneNumber, areas }) => (
  <>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.4rem',
      fontSize: '1.35rem',
      fontWeight: 'bold',
      margin: '1.5rem 0 0.5rem 0',
      direction: 'rtl',
    }}>
      <span style={{ color: '#FFA500', fontSize: '2rem', marginLeft: '0.3rem' }}>
        <span style={{ marginLeft: '0.1rem' }}>&#9733;</span>
        <span style={{ marginLeft: '0.1rem' }}>&#9733;</span>
        <span style={{ marginLeft: '0.1rem' }}>&#9733;</span>
        <span style={{ marginLeft: '0.1rem' }}>&#9733;</span>
        <span style={{ marginLeft: '0.1rem' }}>&#9733;</span>
      </span>
      <span style={{ color: '#222', fontWeight: 'bold', fontSize: '1.15rem', marginTop: '8px' }}>
        4.8/5 - (1,648 تقييم عملاء)
      </span>
    </div>

    <section style={{
      maxWidth: '1100px',
      margin: '2.5rem auto',
      padding: '1.5rem 1rem',
      borderRadius: '1rem',
      boxShadow: '0 2px 12px #0001',
      background: 'linear-gradient(90deg, #0a2c61 0%, #1976d2 100%)',
    }}>
      <div style={{ fontWeight: 'bold', fontSize: '2rem', color: 'var(--color-highlight)', marginBottom: '1.2rem', textAlign: 'center' }}>مناطق التغطية</div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '0.7rem 1.2rem',
        justifyContent: 'center',
        alignItems: 'center',
        direction: 'rtl',
      }}>
        {areas.slice(0, 33).map((area, idx) => (
          <Link
            key={idx}
            to={`/areas/${toArabicSlug(area)}`}
            style={{
              color: '#ffe066',
              textDecoration: 'none',
              fontWeight: 500,
              fontSize: '1.2rem',
              padding: '0.5rem 0.2rem',
              borderRadius: '0.4rem',
              transition: 'background 0.15s',
              textAlign: 'center',
              display: 'block',
            }}
            onMouseOver={e => e.currentTarget.style.background = '#f7f7fa'}
            onMouseOut={e => e.currentTarget.style.background = 'transparent'}
          >
            ونش انقاذ {area}
          </Link>
        ))}
      </div>
      <Link to={`/areas`} className='more-areas-link'>المزيد</Link>
    </section>

    <div style={{ background: '#232328', color: '#fff', padding: '3rem 0 5rem 0', }}>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '4rem',
        maxWidth: '1100px',
        margin: '0 auto',
        alignItems: 'flex-start',
      }}>
        <div style={{ minWidth: 220, flex: 1 }}>
          <div style={{ fontWeight: 'bold', fontSize: '1.25rem', marginBottom: '1rem', borderBottom: '2px solid #fff2', paddingBottom: 8, textAlign: 'right' }}>خدماتنا</div>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'right' }}>
            {['ونش انقاذ', 'ونش انقاذ سيارات', 'رقم ونش انقاذ', 'ارخص ونش انقاذ', 'اقرب ونش انقاذ', 'اسرع ونش انقاذ', 'ونش سيارات'].map((service, idx, arr) => (
              <li key={idx} style={{ marginBottom: 12, fontSize: '1.1rem', borderBottom: idx !== arr.length - 1 ? '1px solid #fff1' : 'none', paddingBottom: 6 }}>{service}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>

    <section
      style={{
        position: 'relative',
        minHeight: '390px',
        width: '100%',
        margin: '0',
        padding: '0',
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(90deg, #0a2c61 0%, #1976d2 100%)',
      }}
      className='back-footer'
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0,0,0,0.81)',
          zIndex: 2,
        }}
      ></div>
      <div
        style={{
          position: 'relative',
          zIndex: 3,
          width: '100%',
          maxWidth: '1400px',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          padding: '3rem 2rem',
          color: '#fff',
          gap: '2rem',
        }}
      >
        <div style={{ flex: '1 1 340px', textAlign: 'right', background: 'rgba(0,0,0,0.55)', borderRadius: '1rem', padding: '2rem 2rem', boxShadow: '0 2px 16px #00000033', marginRight: 'auto' }}>
          <div style={{ fontWeight: 'bold', fontSize: '1.3rem', color: '#ffe600', marginBottom: '1.2rem', borderBottom: '3px solid #ffe600', display: 'inline-block', paddingBottom: '0.2rem' }}>اتصل بنا الان</div>
          <div style={{ fontSize: '1.05rem', margin: '1.2rem 0 1.5rem 0', color: '#fff' }}>
            ونش انقاذ محمد بحر هو اسرع و ارخص ونش انقاذ سيارات اتصل على رقم ونش الانقاذ خدمة 24 ساعة اتصل بنا الان ليصلك اقرب ونش انقاذ سيارات بخصم 50%.
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.7rem', marginBottom: '1.2rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
              <span style={{ background: '#ffe600', borderRadius: '50%', padding: '0.5rem' }}><Phone color='#000' size={20} /></span>
              <span style={{ direction: 'ltr', fontFamily: 'monospace', fontSize: '20px' }}>{phoneNumber}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
              <span style={{ background: '#ffe600', borderRadius: '50%', padding: '0.5rem' }}><Phone color='#000' size={20} /></span>
              <span style={{ direction: 'ltr', fontFamily: 'monospace', fontSize: '20px' }}>الطوارئ و خدمة العملاء: 01034222636</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
              <span style={{ background: '#ffe600', fontSize: '20px', color: '#000', borderRadius: '50%', padding: '0.5rem' }}><FontAwesomeIcon color='#000' size='1xl' icon={faWhatsapp} /></span>
              <span style={{ direction: 'ltr', fontFamily: 'monospace', fontSize: '20px' }}>{phoneNumber}</span>
            </div>
          </div>
          <section style={{
            color: '#ffe600',
            textAlign: 'center',
            padding: '2rem 1rem 1.5rem 1rem',
            fontWeight: 'bold',
            fontSize: '1.35rem',
            lineHeight: '2.2',
            letterSpacing: '0.5px',
            direction: 'rtl',
            boxShadow: '0 2px 12px #00336622',
            borderRadius: '0.7rem',
            margin: '1.5rem 0',
            overflowX: 'auto',
          }}>
            <div style={{ marginBottom: '1.2rem', fontWeight: 500, fontSize: '1.1rem', color: '#ffe600' }}>
              اختيار ونش إنقاذ سيارات موثوق به يضمن لك الأمان والسرعة في الوصول والمساعدة في أصعب الظروف. نحن نعمل على مدار الساعة لتقديم أفضل خدمة إنقاذ سيارات في مصر بأعلى جودة وأقل سعر.
            </div>
            <div>
              ونش انقاذ – ونش انقاذ سيارات – ونش سيارة – اسرع ونش انقاذ – اقرب ونش انقاذ – انقاذ سيارات – ارخص ونش انقاذ – انقاذ السيارات – ونش عربيات – تليفون ونش انقاذ – رقم ونش انقاذ – ونش انقاذ بالقرب مني – انقاذ سيارات – احسن ونش انقاذ سيارات – ونش انقاذ سيارات رخيص – ونش انقاذ سيارات سريع – ونش رفع سيارات – كساحه سيارات – كساحه سحب سيارات – ونش سحب سيارات – ونش هيدروليك
            </div>
          </section>
        </div>
        <div style={{ flex: '1 1 260px', minWidth: '220px', textAlign: 'right' }}>
          <div style={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#ffe600', marginBottom: '1.2rem', borderBottom: '3px solid #ffe600', display: 'inline-block', paddingBottom: '0.2rem' }}>روابط مفيدة</div>
          <div style={{ display: 'flex', gap: '0.5rem 2.5rem', marginTop: '1.5rem' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '10px' }}>
              {areas.slice(0, Math.ceil(areas.length / 2)).map((area, idx) => (
                <Link key={idx} to={`/areas/${toArabicSlug(area)}`} style={{ color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px' }}><Link2 size={15} />ونش انقاذ {area}</Link>
              ))}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '10px' }}>
              {areas.slice(Math.ceil(areas.length / 2)).map((area, idx) => (
                <Link key={idx} to={`/areas/${toArabicSlug(area)}`} style={{ color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px' }}><Link2 size={15} />ونش انقاذ {area}</Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>


  </>
);

export default Home; 